import {
  createSlice,
  //   createSelector,
  createAsyncThunk,
  createEntityAdapter,
} from "@reduxjs/toolkit";
import { uncoveryApi } from "services";

const collectionEditAdapter = createEntityAdapter();
const initialState = collectionEditAdapter.getInitialState({
  isOpenCollectionEditDialog: false,
  editOneStatus: "idle",
  editOneErrorMessage: "",
  data: null,
});

export const editOneCollection = createAsyncThunk(
  "collectionEdit/editOneCollection",
  async ({ entityId, collectionId, payload }, { rejectWithValue }) => {
    const { name, description, color } = payload;
    const query = `/entities/${entityId}/assets/collections/${collectionId}/edit?name=${
      name || ""
    }&description=${description || ""}&color=${
      color ? color.substring(1) : ""
    }`;
    try {
      const response = await uncoveryApi.put(query);
      if (response.status === 200) {
        return response.data;
      } else {
        return rejectWithValue(response.data);
      }
    } catch (e) {
      return rejectWithValue(e.response.data);
    }
  }
);

export const collectionEditSlice = createSlice({
  name: "collectionEdit",
  initialState,
  reducers: {
    setIsOpenCollectionEditDialog: (state, { payload }) => {
      state.isOpenCollectionEditDialog = payload;
      return state;
    },
    resetCollectionEditState: () => initialState,
  },
  extraReducers: {
    [editOneCollection.pending]: (state, { payload }) => {
      state.editOneStatus = "loading";
    },
    [editOneCollection.fulfilled]: (state, { payload }) => {
      state.data = payload.data;
      state.editOneStatus = "success";
    },
    [editOneCollection.rejected]: (state, { payload }) => {
      state.editOneErrorMessage = payload.message;
      state.editOneStatus = "error";
    },
  },
});

export const { setIsOpenCollectionEditDialog, resetCollectionEditState } =
  collectionEditSlice.actions;

export default collectionEditSlice.reducer;

// const collectionEditState = (state) => state.collectionEdit;

// export const selectCollectionIds = createSelector(
//   collectionEditState,
//   (collections) => collections.data.map((collection) => collection.id)
// );
// export const selectCollections = createSelector(
//   collectionEditState,
//   (collections) => collections.data
// );
// export const selectCollectionById = createSelector(
//   [
//     collectionEditState,
//     (collectionEditState, collectionId) => collectionId,
//   ],
//   (collections, collectionId) =>
//     collections.data.find((collection) => collection.id === collectionId)
// );
